<template>
  <b-modal
    id="column-filter-number-modal"
    v-model="active"
    :size="modalSize"
    centered
    hide-footer
    hide-header
    @close="close"
  >
    <svg-icon name="times-bold" :size="8" class="modal-dialog__close" @click="close"></svg-icon>

    <div class="m-column-filters">
      <div class="m-column-filters__wrapper">
        <div class="m-column-filters__item">
          <c-input
            v-model="condition"
            class="m-column-filters__condition"
            type="select"
            size="small"
            :items="conditions"
          />
        </div>
        <div v-if="condition.value !== '4'" class="m-column-filters__item m-column-filters__item_value">
          <c-input
            v-model.number="value"
            class="m-column-filters__value m-column-filters__value_string m-column-filters__value_string_width_45"
            :type="'number'"
            placeholder="0"
            size="small"
          />
        </div>
        <div class="m-column-filters__range">
          <div class="range-wrapper">
            <div v-if="condition.value === '4'" class="m-column-filters__item m-column-filters__item_value">
              <c-input
                v-model="rangeValue.start"
                class="m-column-filters__value m-column-filters__value_string"
                :type="'number'"
                :required-message="error"
                placeholder="0"
                size="small"
              />
            </div>
            <div v-if="condition.value === '4'" class="m-column-filters__item-sep">-</div>
            <div v-if="condition.value === '4'" class="m-column-filters__item m-column-filters__item_value">
              <c-input
                v-model="rangeValue.end"
                class="m-column-filters__value m-column-filters__value_string"
                :type="'number'"
                :required-message="error"
                placeholder="0"
                size="small"
              />
            </div>
          </div>
          <div v-if="error && condition.value === '4'" class="m-column-filters__range__warning">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D" />
              <circle cx="7" cy="10" r="1" fill="#FF238D" />
              <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
            </svg>
            <div class="m-column-filters__range__warning__text">
              {{ error }}
            </div>
          </div>
        </div>
        <div class="m-column-filters__actions">
          <c-button
            class="m-column-filters__action"
            size="small"
            :icon="{ icon: 'check', color: 'success' }"
            :tooltip="'Применить фильтр по столбцу'"
            @click="apply"
          />
          <c-button
            class="m-column-filters__action"
            :tooltip="'Отменить фильтр по столбцу'"
            size="small"
            :icon="{ icon: 'close', color: 'secondary' }"
            @click="reset"
          />
          <c-button class="m-column-filters__action_mobile" label="Сбросить" color="white" @click="reset" />
          <c-button class="m-column-filters__action_mobile" color="primary" label="Применить" @click="apply" />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Button from "@/components/controls2/Button";
import Input from "@/components/controls2/Input";
import SvgIcon from "@/components/svg-icon";

const conditions = [
  { label: "Меньше", value: "1" },
  { label: "Больше", value: "2" },
  { label: "Равно", value: "3" },
  { label: "Диапазон", value: "4" },
];

export default {
  name: "number-filter",
  components: {
    "c-button": Button,
    "c-input": Input,
    SvgIcon,
  },

  data() {
    return {
      active: false,
      submitted: false,

      conditions,
      condition: conditions[0],
      value: "",
      rangeValue: {
        start: "",
        end: "",
      },
    };
  },

  computed: {
    error() {
      if (!this.submitted) return false;

      if (this.condition.value === "4") {
        const range = this.rangeValue;

        if ((!range.start && range.end) || (range.start && !range.end)) {
          return "Укажите диапазон";
        }

        if (range.start > range.end) {
          return "Укажите корректный диапазон";
        }
      }

      return false;
    },
    modalSize() {
      if (this.condition.value !== "4") {
        return "number";
      }
      return "";
    },
  },

  mounted() {
    window.addEventListener("keyup", (event) => {
      if (this.active && event.keyCode === 13) {
        this.apply();
      }
    });
  },

  methods: {
    getParams() {
      if (this.condition.value.toString() === "4") {
        const range = this.rangeValue;
        if (range.start && range.end) {
          return {
            from: this.rangeValue.start,
            to: this.rangeValue.end,
            searchType: this.condition.value,
          };
        }
        return null;
      }

      if (!this.value && this.value !== 0) return null;

      return {
        value: this.value,
        searchType: this.condition.value,
      };
    },

    open(params) {
      this.resetValue();

      if (params) {
        const { searchType } = params;
        const condition = this.conditions.find((c) => c.value === searchType);
        this.condition = condition || conditions[0];
        this.value = params.value;
      }

      this.active = true;
    },
    close() {
      this.active = false;
      this.submitted = false;
      this.$emit("close");
    },
    resetValue() {
      this.value = "";
      const [firstCondition] = conditions;
      this.condition = firstCondition;
      this.rangeValue.start = "";
      this.rangeValue.end = "";
    },
    reset() {
      this.$emit("apply", null);
      this.close();
    },

    apply() {
      this.submitted = true;
      if (this.error) return;

      this.$emit("apply", this.getParams());
      this.close();
    },
  },
};
</script>
